<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import {
    Field,
    FieldActions,
    FieldError,
    FieldHeader,
    FieldLabel,
    FieldValue
  } from '@client/components/fields/standalone/base';
  import { Icon } from '@client/components/icon';
  import { ParamFields } from '@client/components/param-fields';

  import { deepCopyArray } from '@common/utils/arrays';

  export let id = null;
  export let label = null;
  export let value = [];

  export let validationError = undefined;

  export let tooltip = undefined;
  export let tooltipIcon = undefined;

  export let readonly = false;
  export let editing = false;

  export let showActions = true;

  export let onUpdate = () => {};

  let newValue = deepCopyArray(value);

  let disableSubmit = true;
  let error = false;

  const onEdit = () => {
    editing = true;
  };

  const onCancel = () => {
    editing = false;
    newValue = deepCopyArray(value);
  };

  const onSave = () => {
    value = newValue;
    newValue = deepCopyArray(value);

    editing = false;

    if (onUpdate) {
      onUpdate(id, label, value);
    }
  };

  $: disableSubmit = JSON.stringify(value) === JSON.stringify(newValue);
</script>

<Field bind:editing>
  <FieldHeader>
    <FieldLabel {label} {tooltipIcon} {tooltip} bind:error />
    <FieldActions bind:readonly bind:editing bind:disableSubmit {onSave} {onEdit} {onCancel} {showActions} />
  </FieldHeader>
  <FieldValue {showActions}>
    {#if editing}
      <ParamFields bind:params={newValue} framed={false} />
    {:else if value.length}
      <div class="field-list">
        <ul>
          <li class="item headings">
            <span></span>
            <span></span>
            <span>{$format('label.NAME')}</span>
            <span>{$format('label.VALUE')}</span>
          </li>
          {#each value as param, index}
            <li class="item">
              <Icon
                name={param.forceoverride ? 'lock' : 'lock-open'}
                id="param-field-{index}-override"
                color={param.forceoverride ? 'danger' : undefined}
                class="text-medium"
              />
              <Icon
                name={param.nosync ? 'repeat-off' : 'repeat'}
                id="param-field-{index}-sync"
                color={param.nosync ? 'danger' : undefined}
                class="text-medium"
              />
              <div class:empty={!param.name.length}>{@html param.name || $format('label.EMPTY')}</div>
              <div class:empty={!param.default.length}>{@html param.default || $format('label.EMPTY')}</div>

              <Tooltip target="param-field-{index}-override" placement="top">
                {param.forceoverride ? $format('label.FIELD_LOCKED_BY_ADMIN') : $format('label.FIELD_CAN_BE_MODIFIED')}
              </Tooltip>
              <Tooltip target="param-field-{index}-sync" placement="top">
                {param.nosync ? $format('label.FIELD_IS_NOT_BEING_SYNCED') : $format('label.FIELD_IS_BEING_SYNCED')}
              </Tooltip>
            </li>
          {/each}
        </ul>
      </div>
    {:else}
      <div>{$format('label.NO_DEFAULT_FIELDS_FOUND')}</div>
    {/if}
  </FieldValue>
  <FieldError bind:error {validationError} />
  {#if !editing}
    <slot />
  {/if}
</Field>

<style lang="scss" src="./params.scss"></style>
